<template>
  <el-select
    v-model="selectedId"
    filterable
    remote
    clearable
    reserve-keyword
    :remote-method="searchUsers"
    :loading="loading"
    :placeholder="placeholder"
    class="w-220px"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core'
import { getUserLookupOptions, type LookupOption } from '@/api/digital-card/lookup'

defineOptions({ name: 'DigitalCardLookupSelect' })

const props = withDefaults(
  defineProps<{
    modelValue?: number
    placeholder?: string
  }>(),
  {
    placeholder: '请选择用户'
  }
)

const emit = defineEmits<{
  'update:modelValue': [value: number | undefined]
}>()

const loading = ref(false)
const options = ref<LookupOption[]>([])

const selectedId = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

async function fetchUsers(params?: Record<string, any>) {
  loading.value = true
  try {
    const list = await getUserLookupOptions(params)
    options.value = list || []
  } finally {
    loading.value = false
  }
}

const searchUsers = useDebounceFn((keyword: string) => {
  fetchUsers({ keyword: keyword?.trim() || undefined })
}, 300)

async function ensureSelectedOption(id?: number) {
  if (!id) return
  if (options.value.some((item) => item.value === id)) return
  const list = await getUserLookupOptions({ ids: [id] })
  const hit = list?.[0]
  if (!hit) return
  options.value = [hit, ...options.value.filter((item) => item.value !== hit.value)]
}

watch(
  () => props.modelValue,
  (id) => ensureSelectedOption(id),
  { immediate: true }
)

onMounted(() => {
  fetchUsers()
})
</script>
